import { styled } from "@mui/material"
import List from "@mui/material/List"

const StyledList = styled(List)`
  max-width: 60em;
`

export default StyledList
